import React, { useEffect, useRef, useState } from "react";
import { Divider, getIcons, MenuItem, userRole } from "../../Constant/Constant";
import BackArrows from "../../Form/BackArrow/BackArrows";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { IoSettingsOutline } from "react-icons/io5";
import { CiMenuKebab } from "react-icons/ci";
import { MdKeyboardArrowRight } from "react-icons/md";
import SettingModel from "./SettingModel";

const ConnectedPage = () => {
  const location = useLocation();
  const Icon = getIcons();
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const [visibleMenu, setVisibleMenu] = useState(false);
  const [isSettingOpen , setIsSettingOpen] = useState(false);




  const selectedMedia = location.state.selectedMedia;


  const LeadManager = [
    {
        formName : "GL Funnel Manager",
        leadCount : 0
    },
    {
        formName : "Green Lead Manager",
        leadCount : 3
    }

  ]

  const handleBack = () => {
    navigate(-1);
  };

  const handleMenuToggle = () => {
    setVisibleMenu(!visibleMenu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setVisibleMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleFormPageList = (item) => {
  const path = userRole === "Admin" ? "/admin" : "/cmo"
 
    navigate(`${path}/web-hooks-form-list`,{
        state: { 
            formName : item.formName,
            leadCount : item.leadCount
         }
    });
  }

  return (
    <>
      <div className="pt-14 bg-appGrayBackground ">
        <AdminAppBar />
        <ToastContainer />

        {/* {Heading and Search , add } */}
        <div className="mt-[50px] px-6 flex justify-between">
          <div className="flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-6">
                <BackArrows onClick={handleBack} />
                <h1 className="text-[32px] font-semibold">
                  {selectedMedia} Integration
                </h1>
              </div>
            </div>
          </div>
          <div className="relative inline-block text-left" ref={menuRef}>
            <div
              onClick={handleMenuToggle}
              className="bg-white cursor-pointer w-[50px] h-[47px] rounded-xl flex items-center justify-center shadow"
            >
              <CiMenuKebab className="text-customGreen text-3xl" />
            </div>

            {visibleMenu && (
              <div className="absolute right-0 mt-4 w-64 bg-white rounded-xl shadow-lg z-10 ">
                <div className="absolute -top-2 rounded right-4 w-4 h-4 bg-white rotate-45"></div>

                <div className="py-2">
                  <MenuItem label="Manage Page" />
                  <Divider />
                  <MenuItem label="Renew Permissions" />
                  <Divider />
                  <MenuItem label="Refresh Lead forms" />
                  <Divider />
                  <MenuItem label="Import past leads" />
                  <Divider />
                  <MenuItem label="View Facebook help guide" />
                  <Divider />
                  <MenuItem
                    label="Disconnect Account"
                    textColor="text-red-600"
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="px-6">
          {/* {Connected Page Content} */}

          <div className="bg-white rounded-lg px-5 py-3 mt-[50px] flex items-center justify-between ">
            <div className="flex items-center gap-3">
              <img src={Icon.faceBookIcon} />
              <div className="text-slate-700 text-lg font-medium">
                GL Funnel
              </div>
            </div>

            <div className="text-base  bg-slate-100 rounded-full py-2 px-3 text-customGreen ">
              Connect
            </div>
          </div>

          {/* {Connected Pages list} */}

          <div className="mt-[30px]">
            <div className="flex items-center justify-between ">
              <div className="text-2xl font-medium">Connected Pages </div>
              <IoSettingsOutline onClick={()=>setIsSettingOpen(true)} className="text-3xl cursor-pointer hover:text-customGreen" />
            </div>

            <div className="bg-white p-6 rounded-lg mt-[30px]">
                {
                    LeadManager.map((item,index)=>(
                        <div key={index} onClick={()=>handleFormPageList(item)} className="flex mb-3 justify-between bg-slate-100 rounded-lg px-5 py-2 items-center cursor-pointer ">
                        <div className="flex flex-col gap-1 text-slate-700">
                          <div className="font-medium">{item.formName}</div>
                          <div className="text-slate-500">{item.leadCount > 0 ? `${item.leadCount} Lead forms found` : 'No Lead forms found'}</div>
                        </div>
                        <MdKeyboardArrowRight className="text-3xl bg- " />
                      </div>
                    ))
                }
             

              <div className="bg-green-100 p-5 rounded-lg mt-5 flex flex-col gap-3">
                <div className="text-base font-medium text-customGreen">
                  Optimise Your Campaigns With META Conversions API
                </div>
                <div className="text-slate-700">
                  Improve lead quality & reduce cost by setting up Meta
                  conversions API with GL Funnel to optimise your lead ad
                  Campaigns
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SettingModel 
      isOpen={isSettingOpen}
      close={
        ()=>setIsSettingOpen(false)
      }
      />
    </>
  );
};

export default ConnectedPage;
